/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import { limitsHandler } from "../../limits/index";
import { modalityHandler } from "../../modality/index";
import { format, parseISO } from 'date-fns';

async function handleInitialAdjustments({
  questionnaire,
  scoreInformationData,
  handleGetInfoCCGProvider
}) {
  const usesProviderCCG = questionnaire.find(
    qst => qst.idQuestion === 2007
  )?.idAnswerOption === 7684;

  const currentCCGNumber = questionnaire.find(
    qst => qst.idQuestion === 2008
  )?.answer;

  const {value: personLegalId, id: idPerson} = JSON.parse(currentCCGNumber || '{}');

  const providerCCGInfo = handleGetInfoCCGProvider && await handleGetInfoCCGProvider(
    idPerson,
    personLegalId
  );

  const hasBorrowerInfo = (providerCCGInfo?.borrowerLegalId && providerCCGInfo?.borrowerPersonId);

  return questionnaire.map(question => {

    if (question.idQuestion === 1676) {
      if (!question.answer) question.answer = 900;

      const qstSompoCredit = questionnaire.find(v => v.idQuestion === 1677);

      if (!qstSompoCredit.answer) {
        const creditScoreSompo = scoreInformationData.find(scoreInfo => scoreInfo.score == question.answer);
        qstSompoCredit.answer = creditScoreSompo?.scoreSompo || 'Não Calculado';
      }
    }

    if (question.idQuestion === 1717) {
      const qst = questionnaire.find(v => v.idQuestion === 1637);
      const { answer } = qst;
      let response;

      if (answer > 1000000) {
        response = question.answerOptions.find(ansOp => ansOp.idAnswerOption == 7331);
      } else if (answer <= 1000000) {
        response = question.answerOptions.find(ansOp => ansOp.idAnswerOption == 7332);
      }

      question.answer = response.behaviorObject.resultValue;
      question.idAnswerOption = response.idAnswerOption;
    }

    if ([1726, 1727, 1728, 1813].includes(question.idQuestion)) {
      question.behaviorObject.isReadOnly = true;
      question.disabled = true;

      if (question.idQuestion === 1813) {
        question.visibleQuestion = !!question.answer;
      } else if(question.idQuestion === 1726) {
        const answerOpt = question.answerOptions.find(
          opt => opt.idAnswerOption === providerCCGInfo[question.idQuestion]
        );

        question.answer = answerOpt?.dsAnswerOption || '';
        question.idAnswerOption = answerOpt?.idAnswerOption || null;
        
        question.behaviorObject.desktopWidth = 20;
        question.visibleQuestion = true;
      } else if ([1727, 1728].includes(question.idQuestion)) {
        question.answer = providerCCGInfo[question.idQuestion] ?? '';
        question.visibleQuestion = true;
        question.behaviorObject.isRequired = false;
      }
    }

    if (question.idQuestion === 2007) {
      if (!question?.idAnswerOption && hasBorrowerInfo) {
        const answerOpt = question.answerOptions.find(
          opt => opt.idAnswerOption === 7685
        );

        question.answer = answerOpt?.dsAnswerOption || '';
        question.idAnswerOption = answerOpt?.idAnswerOption || null;
      }
      question.behaviorObject.desktopWidth = 20;
    } else if (question.idQuestion === 2008) {
      if (!question.answer && hasBorrowerInfo) {
        const answer = JSON.stringify({ 
          value: providerCCGInfo.borrowerLegalId,
          id: providerCCGInfo.borrowerPersonId
        });
        
        question.answer = answer;
				question.answerJson = answer;
      }
      question.behaviorObject.desktopWidth = 20;
      question.behaviorObject.isReadOnly = !usesProviderCCG;
      question.disabled = !usesProviderCCG;
      question.behaviorObject.isRequired = usesProviderCCG;
    }

    if (question.idQuestion === 1829) {
      const isEconomicGroup = questionnaire.find(qst => qst.idQuestion === 1830)?.idAnswerOption === 7415;
      const isProject = questionnaire.find(qst => qst.idQuestion === 1723)?.idAnswerOption === 7336;

      if (!isEconomicGroup || isProject) {
        question.behaviorObject.isReadOnly = true;
        question.disable = true
      }
    }

    if (question.idQuestion === 1830) {
      const isProject = questionnaire.find(qst => qst.idQuestion === 1723)?.idAnswerOption === 7336;

      if (isProject) {
        question.behaviorObject.isReadOnly = true;
        question.disable = true
      }
    }

    return question;
  })
}

async function handleQuestionChange({
  question,
  value,
  questionnaireUpdated,
  setQuestionnaire,
  setFieldValue,
  limits,
  setLimits,
  setCanUpdateBorrowerSRO,
  economicGroup,
  mc,
  handleGetInfoCCGProvider
}) {
  if ([1830].includes(question.idQuestion) && value && setCanUpdateBorrowerSRO) {
    setCanUpdateBorrowerSRO(true);
  }

  let saveFilteredQuestionnaire = false;

  if ([1667, 1668].includes(question.idQuestion)) {
    let subQuestionDisabled = false;

    const claimCompensatedQst = questionnaireUpdated.find(qst => qst.idQuestion == 1667 && qst.idAnswerOption == 7273);

    if (claimCompensatedQst) {
      subQuestionDisabled = true;
    }

    limits = limits.map(limit => {
      limit = limit.map(item => {
        if (value && value != "" && [7273, 7275].includes(value.idAnswerOption)) {
          if ([1687].includes(item.idQuestion)) {
            if ([7284, 7285, 7286, 7407].includes(item.idAnswerOption)) {
              item.idAnswerOption = 7284;

              let answerOptionSelected = item.answerOptions.find(option => option.idAnswerOption == 7284);

              item.answer = answerOptionSelected.dsAnswerOption;
              item.answerJson = answerOptionSelected.dsAnswerOption;
              item.disabled = subQuestionDisabled;

              const result = {
                dsAnswerOption: answerOptionSelected?.dsAnswerOption,
                idAnswerOption: answerOptionSelected?.idAnswerOption,
                resultValue: null
              };

              setFieldValue && setFieldValue(item.key, result);

              limits = limits.map(limit => {
                limit = limit.map(qst => {
                  qst.disabled = ![7286, 7285, 7407].includes(item?.idAnswerOption);

                  if (qst.idQuestion === 1687 && [7284].includes(item?.idAnswerOption)) {
                    qst.disabled = subQuestionDisabled;
                  }

                  return qst
                })

                return limit;
              })
            }
          }
        } else {
          if ([1687].includes(item.idQuestion)) {
            limits = limits.map(limit => {
              limit = limit.map(qst => {
                qst.disabled = ![7286, 7285].includes(item?.idAnswerOption);

                if (qst.idAnswerOption == 7354) qst.disabled = true;

                if (qst.idQuestion === 1687 && [7284].includes(item?.idAnswerOption)) {
                  qst.disabled = subQuestionDisabled;
                  if (qst.idAnswerOption == 7354) qst.disabled = true;
                }

                return qst
              })
              return limit;
            })
          }
        }

        return item;
      })

      return limit;
    })

    setLimits(limits)
  }

  if (question.idQuestion === 1676 && value) {
    saveFilteredQuestionnaire = true;
    let response;

    questionnaireUpdated = questionnaireUpdated.map(qst => {
      if (qst.idQuestion === 1715) {
        if (value < 600) {
          response = qst.answerOptions.find(ansOp => ansOp.idAnswerOption == 7321);
        } else if (value >= 600 && value <= 700) {
          response = qst.answerOptions.find(ansOp => ansOp.idAnswerOption == 7322);
        } else if (value >= 701 && value <= 750) {
          response = qst.answerOptions.find(ansOp => ansOp.idAnswerOption == 7323);
        } else if (value >= 751 && value <= 800) {
          response = qst.answerOptions.find(ansOp => ansOp.idAnswerOption == 7324);
        } else if (value >= 801 && value <= 900) {
          response = qst.answerOptions.find(ansOp => ansOp.idAnswerOption == 7325);
        } else if (value >= 901 && value <= 1000) {
          response = qst.answerOptions.find(ansOp => ansOp.idAnswerOption == 7326);
        }

        qst.answer = response.dsAnswerOption;
        qst.idAnswerOption = response.idAnswerOption;
      }

      return qst;
    })
  }

  if (question.idQuestion === 1830) {
    saveFilteredQuestionnaire = true;

    questionnaireUpdated = questionnaireUpdated.map(qst => {
      if (qst.idQuestion === 1829) {
        if (value?.idAnswerOption === 7414) {
          const foundQuestionOption = qst.answerOptions.find(v => v.idAnswerOption === 7412);

          qst.answer = foundQuestionOption?.dsAnswerOption;
          qst.answerJson = foundQuestionOption?.dsAnswerOption;
          qst.idAnswerOption = foundQuestionOption?.idAnswerOption;
          qst.behaviorObject.isReadOnly = true;
          qst.disable = true

          setFieldValue(qst.key, {
            dsAnswerOption: foundQuestionOption?.dsAnswerOption,
            idAnswerOption: foundQuestionOption?.idAnswerOption,
            resultValue: null
          })
        }

        if (value?.idAnswerOption === 7415) {
          qst.behaviorObject.isReadOnly = false;
          qst.disable = false
        }
      }

      if (qst.idQuestion === 1723) {
        if (value?.idAnswerOption === 7415) {
          const foundQuestionOption = qst.answerOptions.find(v => v.idAnswerOption === 7335);

          qst.answer = foundQuestionOption?.dsAnswerOption;
          qst.answerJson = foundQuestionOption?.dsAnswerOption;
          qst.idAnswerOption = foundQuestionOption?.idAnswerOption;
          qst.behaviorObject.isReadOnly = true;
          qst.disable = true

          setFieldValue(qst.key, {
            dsAnswerOption: foundQuestionOption?.dsAnswerOption,
            idAnswerOption: foundQuestionOption?.idAnswerOption,
            resultValue: null
          })
        }

        if (value?.idAnswerOption === 7414) {
          qst.behaviorObject.isReadOnly = false;
          qst.disable = false
        }
      }

      return qst;
    })
  }

  if (question.idQuestion === 1829) {
    const economicGroupIsGuarantee = value?.idAnswerOption === 7413;
    
    const quantityAffiliates = economicGroup.filter(ec => {
      const flagUseGroupCCG = ec.questions.find(qst => qst.idQuestion === 1851)?.idAnswerOption;
      if (
        !ec.isHead && 
        !ec.personRelationshipExpireDate && 
        flagUseGroupCCG === (economicGroupIsGuarantee ? 7463 : 7462)
      ) return ec;
    })?.length;

    if (mc && quantityAffiliates) {
      const warningMsg = economicGroupIsGuarantee ?
        `Atenção! Este grupo contém ${quantityAffiliates} entidades com CCG individual vinculadas. 
        Para avaliza-los, necessário alterar o parâmetro do CCG 
        para "Utiliza CCG do provedor do limite?" = Sim.` :
        `Atenção! Este grupo contém ${quantityAffiliates} entidades que utilizam o CCG do Grupo. 
        Para alterar esse vínculo é necessário alterar o parâmetro do CCG 
        para "Utiliza CCG do provedor do limite?" = Não.`
        
      mc.error(warningMsg);
    }
  } else if (question.idQuestion === 2007) {
		saveFilteredQuestionnaire = true;
		
    const usesProviderCCG = value?.idAnswerOption === 7684;
    const providerCCGInfo = handleGetInfoCCGProvider && await handleGetInfoCCGProvider();

		questionnaireUpdated = questionnaireUpdated.map(qst => {
      if (usesProviderCCG && [1726, 1727, 1728, 2008].includes(qst.idQuestion)) {
        qst.answer = '';
        qst.idAnswerOption = null;
        
        setFieldValue(qst.key, '');
        
        if (qst.idQuestion === 2008) {
          qst.behaviorObject.isReadOnly = false;
          qst.disabled = false;
          qst.behaviorObject.isRequired = true;
        }

        return qst;
      }

      if(qst.idQuestion === 1726) {
        const answerOpt = qst.answerOptions.find(
          opt => opt.idAnswerOption === providerCCGInfo[qst.idQuestion]
        );

        qst.answer = answerOpt?.dsAnswerOption || '';
        qst.idAnswerOption = answerOpt?.idAnswerOption || null;
        
        setFieldValue(
          qst.key,
          answerOpt ? {
            dsAnswerOption: qst.answer,
            idAnswerOption: qst.idAnswerOption,
            resultValue: null
          } : ''
        );
      } else if ([1727, 1728].includes(qst.idQuestion)) {
        qst.answer = providerCCGInfo[qst.idQuestion] ?? '';
        
        setFieldValue(
          qst.key, 
          qst.answer ? format(parseISO(qst.answer), 'dd/MM/yyyy') : ''
        );
      } else if (qst.idQuestion === 2008) {
        qst.answer = JSON.stringify({ 
          value: providerCCGInfo.borrowerLegalId,
          id: providerCCGInfo.borrowerPersonId
        });
        
        setFieldValue(qst.key, providerCCGInfo.borrowerLegalId);
        
        qst.behaviorObject.isReadOnly = true;
        qst.disabled = true;
        qst.behaviorObject.isRequired = false;
			}
			return qst;
		});
  } else if (question.idQuestion === 2008 && value?.value && value?.id) {
    saveFilteredQuestionnaire = true;
    
    const providerCCGInfo = handleGetInfoCCGProvider && await handleGetInfoCCGProvider(
      value.id, //borrowerPersonId
      value.value //borrowerLegalId
    );

    questionnaireUpdated = questionnaireUpdated.map(qst => {
      if(qst.idQuestion === 1726) {
        const answerOpt = qst.answerOptions.find(
          opt => opt.idAnswerOption === providerCCGInfo[qst.idQuestion]
        );

        qst.answer = answerOpt?.dsAnswerOption || '';
        qst.idAnswerOption = answerOpt?.idAnswerOption || null;

        setFieldValue(
          qst.key,
          answerOpt ? {
            dsAnswerOption: qst.answer,
            idAnswerOption: qst.idAnswerOption,
            resultValue: null
          } : ''
        );
      } else if ([1727, 1728].includes(qst.idQuestion)) {
        qst.answer = providerCCGInfo[qst.idQuestion] ?? '';
        
        setFieldValue(
          qst.key, 
          qst.answer ? format(parseISO(qst.answer), 'dd/MM/yyyy') : ''
        );
      }
			return qst;
		});
  }

  if (saveFilteredQuestionnaire) setQuestionnaire(questionnaireUpdated);
}

function handleQuestionBlur({
  question,
  value,
  questionnaireUpdated,
  setQuestionnaire,
  setFieldValue,
  limits,
  modalities,
  setModalities,
  modalitiesFeesData,
  scoreInformationData,
  setQuestionnaireAnswersToDelete,
  questionnaireAnswersToDelete,
  questionAnswersSERASA,
  globalQuestionnaire
}) {
  try {
    let saveFilteredQuestionnaire = false;

    if (question.idQuestion === 1663) {
      saveFilteredQuestionnaire = true;

      const answerOptionSelected = question.answerOptions.find(option => option.idAnswerOption == (value.retorno == 1 ? 7265 : 7266));

      question.answer = answerOptionSelected.dsAnswerOption;
      question.answerJson = answerOptionSelected.dsAnswerOption;
      question.idAnswerOption = answerOptionSelected.idAnswerOption;

      const result = {
        dsAnswerOption: answerOptionSelected?.dsAnswerOption,
        idAnswerOption: answerOptionSelected?.idAnswerOption,
        resultValue: null
      };

      setFieldValue && setFieldValue(question.key, result)
    }

    if (question.idQuestion === 1666) {
      saveFilteredQuestionnaire = true;

      const answerOptionSelected = question.answerOptions.find(option => option.idAnswerOption == (value.areInDefault ? 7271 : 7272));

      question.answer = answerOptionSelected.dsAnswerOption;
      question.answerJson = answerOptionSelected.dsAnswerOption;
      question.idAnswerOption = answerOptionSelected.idAnswerOption;

      const result = {
        dsAnswerOption: answerOptionSelected?.dsAnswerOption,
        idAnswerOption: answerOptionSelected?.idAnswerOption,
        resultValue: null
      };

      setFieldValue && setFieldValue(question.key, result)
    }

    if ([1670, 1671, 1672, 1673, 1674, 1675, 1676].includes(question.idQuestion)) {
      question.answer = value;
      setFieldValue(question.key, value)

      if (question.idQuestion === 1676) {
        saveFilteredQuestionnaire = true;

        const qst = questionnaireUpdated.find(v => v.idQuestion === 1677);
        const creditScoreSompo = scoreInformationData.find(scoreInfo => scoreInfo.score == value);
        qst.answer = creditScoreSompo?.scoreSompo || "Não calculado";
        setFieldValue(qst.key, creditScoreSompo?.scoreSompo || "Não calculado");
      }

      if (questionAnswersSERASA) {
        questionnaireUpdated = questionnaireUpdated.map(qst => {
          if (qst.idQuestion === 1670) {
            qst.answer = questionAnswersSERASA["1670"];
            setFieldValue(qst.key, questionAnswersSERASA["1670"]);
          }
          if (qst.idQuestion === 1671) {
            qst.answer = questionAnswersSERASA["1671"];
            setFieldValue(qst.key, questionAnswersSERASA["1671"]);
          }
          if (qst.idQuestion === 1672) {
            qst.answer = questionAnswersSERASA["1672"];
            setFieldValue(qst.key, questionAnswersSERASA["1672"]);
          }
          if (qst.idQuestion === 1673) {
            qst.answer = questionAnswersSERASA["1673"];
            setFieldValue(qst.key, questionAnswersSERASA["1673"]);
          }
          if (qst.idQuestion === 1675) {
            qst.answer = questionAnswersSERASA["1675"];
            setFieldValue(qst.key, questionAnswersSERASA["1675"]);
          }
          if (qst.idQuestion === 1676) {
            qst.answer = questionAnswersSERASA["1676"];
            setFieldValue(qst.key, questionAnswersSERASA["1676"]);
          }

          if (qst.idQuestion === 1715) {
            let response;

            if (value === "NÃO INFORMADO") {
              response = qst.answerOptions.find(ansOp => ansOp.idAnswerOption == 7408);
            } else if (value === "NÃO CALCULADO") {
              response = qst.answerOptions.find(ansOp => ansOp.idAnswerOption == 7402);
            } else if (value === "DEFAULT") {
              response = qst.answerOptions.find(ansOp => ansOp.idAnswerOption == 7403);
            } else if (value < 600) {
              response = qst.answerOptions.find(ansOp => ansOp.idAnswerOption == 7321);
            } else if (value >= 600 && value <= 700) {
              response = qst.answerOptions.find(ansOp => ansOp.idAnswerOption == 7322);
            } else if (value >= 701 && value <= 750) {
              response = qst.answerOptions.find(ansOp => ansOp.idAnswerOption == 7323);
            } else if (value >= 751 && value <= 800) {
              response = qst.answerOptions.find(ansOp => ansOp.idAnswerOption == 7324);
            } else if (value >= 801 && value <= 900) {
              response = qst.answerOptions.find(ansOp => ansOp.idAnswerOption == 7325);
            } else if (value >= 901 && value <= 1000) {
              response = qst.answerOptions.find(ansOp => ansOp.idAnswerOption == 7326);
            }
            qst.answer = response.dsAnswerOption;
            qst.idAnswerOption = response.idAnswerOption;
          }

          return qst;
        })
      }

      handleCalcPefinRefinAcoesProtCapSocial({
        questionnaire: questionnaireUpdated,
        setFieldValue
      });
      const isProject = globalQuestionnaire.find(qst => qst.idQuestion === 1723)?.idAnswerOption === 7336;
      const consumedLimitGroup = limits[limits?.length - 1]?.find(qst => qst.idQuestion === 1832)?.idAnswerOption === 7419;
      
      if (!(isProject && consumedLimitGroup)) {
        limitsHandler.events.handleLimits({
          questionnaire: questionnaireUpdated,
          limits,
          setFieldValue
        });

        modalityHandler.events.handleModalities({
          questionnaire: questionnaireUpdated,
          modalitiesFeesData,
          scoreInformationData,
          modalities,
          setModalities,
          setFieldValue,
          setQuestionnaireAnswersToDelete,
          questionnaireAnswersToDelete,
          limitValueOverwrite: null
        });
      }
    }

    if (saveFilteredQuestionnaire) setQuestionnaire(questionnaireUpdated);
  } catch (e) {
    console.log("CREDIT_ANALYSIS_INFO - handleQuestionBlur error", e)
  }
}

function handleCalcPefinRefinAcoesProtCapSocial({
  questionnaire,
  setFieldValue
}) {
  const qstCapitalSocialValue = questionnaire.find(v => v.idQuestion === 1637)?.answer;
  const qstPEFINValue = questionnaire.find(v => v.idQuestion === 1672)?.answer;
  const qstREFINValue = questionnaire.find(v => v.idQuestion === 1673)?.answer;
  const qstAcoesProtestosValue = questionnaire.find(v => v.idQuestion === 1670)?.answer;


  const qstPefinRefinAcoesProtCapSocial = questionnaire.find(v => v.idQuestion === 1678);

  if (qstPefinRefinAcoesProtCapSocial && qstCapitalSocialValue > 0) {
    qstPefinRefinAcoesProtCapSocial.answer = (+((+qstPEFINValue + +qstREFINValue + +qstAcoesProtestosValue) / +qstCapitalSocialValue) * 100).toFixed(5);


    setFieldValue && setFieldValue(qstPefinRefinAcoesProtCapSocial.key, qstPefinRefinAcoesProtCapSocial.answer);
  }

  handleRestritivos({ questionnaire, setFieldValue })
}

function handleRestritivos({
  questionnaire,
  setFieldValue
}) {
  const qstPefinRefinAcoesProtCapSocialValue = questionnaire.find(v => v.idQuestion === 1678)?.answer;

  const qstRestrictive = questionnaire.find(v => v.idQuestion === 1716);
  if (qstRestrictive) {
    if (qstPefinRefinAcoesProtCapSocialValue < 10) {
      // qstRestrictive.answer = 1;
      qstRestrictive.idAnswerOption = 7327;
      qstRestrictive.answer = qstRestrictive.answerOptions.find(ansOp => ansOp.idAnswerOption == 7327)?.behaviorObject?.resultValue;
    } else if (qstPefinRefinAcoesProtCapSocialValue >= 10 && qstPefinRefinAcoesProtCapSocialValue <= 20) {
      // qstRestrictive.answer = 0.6;
      qstRestrictive.idAnswerOption = 7328;
      qstRestrictive.answer = qstRestrictive.answerOptions.find(ansOp => ansOp.idAnswerOption == 7328)?.behaviorObject?.resultValue;
    } else if (qstPefinRefinAcoesProtCapSocialValue > 20 && qstPefinRefinAcoesProtCapSocialValue <= 30) {
      // qstRestrictive.answer = 0.4;
      qstRestrictive.idAnswerOption = 7329;
      qstRestrictive.answer = qstRestrictive.answerOptions.find(ansOp => ansOp.idAnswerOption == 7329)?.behaviorObject?.resultValue;
    } else if (qstPefinRefinAcoesProtCapSocialValue > 30) {
      // qstRestrictive.answer = 0;
      qstRestrictive.idAnswerOption = 7330;
      qstRestrictive.answer = qstRestrictive.answerOptions.find(ansOp => ansOp.idAnswerOption == 7330)?.behaviorObject?.resultValue;
    }

    console.log('handleQuestionChange - handleRestrictive - qstRestrictive.answer', qstRestrictive.answer);

    limitsHandler.events.handleLimiteCalculado({ questionnaire, setFieldValue })
  }
}

const events = {
  handleInitialAdjustments,
  handleQuestionChange,
  handleQuestionBlur,
  handleCalcPefinRefinAcoesProtCapSocial,
  handleRestritivos,
}

export { events };
